const isLyp = (location, rootPath) => {
    const lypPath = `${rootPath}`;
    return location && location.pathname
        ? location.pathname.indexOf(lypPath) !== -1
        : false;
};

const isAddressValid = (serverAddressValidation) => {
    const keys = Object.keys(serverAddressValidation);
    const isValid = keys.reduce((acc, k) => (acc && serverAddressValidation[k].isValid), true);
    return isValid;
};

const getFuzzyLatLng = (
    isAddressV2,
    serverAddressValidation,
    latlng,
    geocoderLatLng,
    partialMatch
) => {
    let fuzzy = true;
    let latitude = 0.0;
    let longitude = 0.0;
    if (isAddressV2) {
        // Fuzzy will be set to true when the address is not fully validated
        fuzzy = !isAddressValid(serverAddressValidation)
     || (
         // Fuzzy will be set to true when the address is partially matched
         partialMatch
         // Fuzzy will be set to true when latLng is null
         || !latlng
         // Fuzzy will be set to true if latLng is an empty object
         || Object.keys(latlng).length === 0
         // Fuzzy will be set to true if either lat or lng are 0
         || !latlng.lat
         || !latlng.lng
     );
        // latitude will be 0 if there is no latlng or if it is null
        latitude = (!latlng || Object.keys(latlng).length === 0 || !latlng.lat)
            ? 0
            : latlng.lat;
        // longitude will be 0 if there is no latlng or if it is null
        longitude = (!latlng || Object.keys(latlng).length === 0 || !latlng.lng)
            ? 0
            : latlng.lng;
        return {
            fuzzy,
            latitude,
            longitude
        };
    }
    if (
        Object.keys(latlng ?? {}).length !== 0
        && latlng.lat
        && latlng.lng
    ) {
        latitude = latlng.lat;
        longitude = latlng.lng;
        fuzzy = false;
        if (geocoderLatLng.threshold && geocoderLatLng.threshold >= 1500) {
            // When threshold value is very high, we set fuzzy to true if the user
            // uses the value returned (doesnt move the pin)
            fuzzy = latitude === geocoderLatLng.value.lat && longitude === geocoderLatLng.value.lng;
        }
        return {
            latitude,
            longitude,
            fuzzy
        };
    }
    return {
        latitude,
        longitude,
        fuzzy
    };
};

export {
    // eslint-disable-next-line import/prefer-default-export
    isLyp,
    getFuzzyLatLng
};
